import React, { useEffect, useState } from "react";
import Cargando from '../componentes/auth/Cargando';
import Firebase from './firebaseConfig';

export const Auth = React.createContext();

const nombre_webinar = "demo";
const app = new Firebase();

export const AuthContext = ({ children }) => {
    const [usuario, setUsuario] = useState(null);
    const [showChild, setShowChild] = useState(false);
    const [datos, setDatos] = useState({});

    
    useEffect(() => {
        app.app.auth().onAuthStateChanged(function(user) {

            setDatos(JSON.parse(localStorage.getItem('usuario')));
            setUsuario(user);
            setShowChild(true);
            
        });
    }, []);

    if (!showChild) {
        return <Cargando/>;
    } else {
        return (
            <Auth.Provider
                value={{
                    usuario, datos, setDatos
                }}
            >
                {children}
            </Auth.Provider>
        );
    }
};
